<template>
  <div class="bdd bdd-single">
    <div class="bddbtn" :class="{ has: isOpen }">
      <span class="bddmain" :title="label" @click="toggleDropdown">
        <span>{{ selectedLabel }}</span>
      </span>
      <span class="bddcar" :title="label" @click="toggleDropdown">▾</span>
    </div>

    <template v-if="isOpen">
      <div class="bdd-back" @click="closeDropdown" />
      <div class="bddmenu">
        <div class="bddhead">
          <span>{{ label }}</span>
        </div>

        <button
          v-for="option in options"
          :key="String(option.value)"
          type="button"
          class="bdditem bdditem-btn"
          :class="{ active: isSelected(option.value) }"
          @click="selectValue(option.value)"
        >
          <span>{{ option.label }}</span>
          <i v-if="isSelected(option.value)" class="fas fa-check"></i>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    modelValue: {
      type: [String, Number],
      required: true
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    selectedLabel() {
      const selected = this.options.find((option) => String(option.value) === String(this.modelValue));
      return selected ? selected.label : '';
    }
  },
  methods: {
    isSelected(value) {
      return String(value) === String(this.modelValue);
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    selectValue(value) {
      this.$emit('update:modelValue', value);
      this.closeDropdown();
    }
  }
};
</script>
